// extracted by mini-css-extract-plugin
export default {"container":"Aq-z","ratingLayout":"Bq-z","ratingLabel":"Cq-z","nonInteractiveRatingLabel":"Dq-z"};